import $appState from '../services/app-state';

export default async (to, from, next) => {
  if (!to.meta.withContext) {
    $appState.context = null;
    $appState.showContextSidenav = false;
  } else {
    $appState.showContextSidenav = true;
  }

  return next();
};
